import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'AD', name: 'Andorra' },
    { value: 2, label: 'AE', name: 'United Arab Emirates' },
    { value: 3, label: 'AF', name: 'Afghanistan' },
    { value: 4, label: 'AG', name: 'Antigua and Barbuda' },
    { value: 5, label: 'AI', name: 'Anguilla' },
    { value: 6, label: 'AL', name: 'Albania' },
    { value: 7, label: 'AM', name: 'Armenia' },
    { value: 8, label: 'AN', name: 'Netherlands Antilles' },
    { value: 9, label: 'AO', name: 'Angola' },
    { value: 10, label: 'AQ', name: 'Antarctica' },
    { value: 11, label: 'AR', name: 'Argentina' },
    { value: 12, label: 'AS', name: 'American Samoa' },
    { value: 13, label: 'AT', name: 'Austria' },
    { value: 14, label: 'AU', name: 'Australia' },
    { value: 15, label: 'AW', name: 'Aruba' },
    { value: 16, label: 'AZ', name: 'Azerbaijan' },
    { value: 17, label: 'BA', name: 'Bosnia and Herzegovina' },
    { value: 18, label: 'BB', name: 'Barbados' },
    { value: 19, label: 'BD', name: 'Bangladesh' },
    { value: 20, label: 'BE', name: 'Belgium' },
    { value: 21, label: 'BF', name: 'Burkina Faso' },
    { value: 22, label: 'BG', name: 'Bulgaria' },
    { value: 23, label: 'BH', name: 'Bahrain' },
    { value: 24, label: 'BI', name: 'Burundi' },
    { value: 25, label: 'BJ', name: 'Benin' },
    { value: 26, label: 'BL', name: 'Saint-Barthélemy' },
    { value: 27, label: 'BM', name: 'Bermuda' },
    { value: 28, label: 'BN', name: 'Brunei Darussalam' },
    { value: 29, label: 'BO', name: 'Bolivia' },
    { value: 30, label: 'BR', name: 'Brazil' },
    { value: 31, label: 'BS', name: 'Bahamas' },
    { value: 32, label: 'BT', name: 'Bhutan' },
    { value: 33, label: 'BV', name: 'Bouvet Island' },
    { value: 34, label: 'BW', name: 'Botswana' },
    { value: 35, label: 'BY', name: 'Belarus' },
    { value: 36, label: 'BZ', name: 'Belize' },
    { value: 37, label: 'CA', name: 'Canada' },
    { value: 38, label: 'CC', name: 'Cocos (Keeling) Islands' },
    { value: 39, label: 'CD', name: 'Congo, (Kinshasa)' },
    { value: 40, label: 'CF', name: 'Central African Republic' },
    { value: 41, label: 'CG', name: 'Congo (Brazzaville)' },
    { value: 42, label: 'CH', name: 'Switzerland' },
    { value: 43, label: 'CI', name: "Côte d'Ivoire" },
    { value: 44, label: 'CK', name: 'Cook Islands' },
    { value: 45, label: 'CL', name: 'Chile' },
    { value: 46, label: 'CM', name: 'Cameroon' },
    { value: 47, label: 'CN', name: 'China' },
    { value: 48, label: 'CO', name: 'Colombia' },
    { value: 49, label: 'CR', name: 'Costa Rica' },
    { value: 50, label: 'CU', name: 'Cuba' },
    { value: 51, label: 'CV', name: 'Cape Verde' },
    { value: 52, label: 'CX', name: 'Christmas Island' },
    { value: 53, label: 'CY', name: 'Cyprus' },
    { value: 54, label: 'CZ', name: 'Czech Republic' },
    { value: 55, label: 'DE', name: 'Germany' },
    { value: 56, label: 'DJ', name: 'Djibouti' },
    { value: 57, label: 'DK', name: 'Denmark' },
    { value: 58, label: 'DM', name: 'Dominica' },
    { value: 59, label: 'DO', name: 'Dominican Republic' },
    { value: 60, label: 'DZ', name: 'Algeria' },
    { value: 61, label: 'EC', name: 'Ecuador' },
    { value: 62, label: 'EE', name: 'Estonia' },
    { value: 63, label: 'EG', name: 'Egypt' },
    { value: 64, label: 'EH', name: 'Western Sahara' },
    { value: 65, label: 'ER', name: 'Eritrea' },
    { value: 66, label: 'ES', name: 'Spain' },
    { value: 67, label: 'ET', name: 'Ethiopia' },
    { value: 68, label: 'FI', name: 'Finland' },
    { value: 69, label: 'FJ', name: 'Fiji' },
    { value: 70, label: 'FK', name: 'Falkland Islands (Malvinas)' },
    { value: 71, label: 'FM', name: 'Micronesia, Federated States of' },
    { value: 72, label: 'FO', name: 'Faroe Islands' },
    { value: 73, label: 'FR', name: 'France' },
    { value: 74, label: 'GA', name: 'Gabon' },
    { value: 75, label: 'GB', name: 'United Kingdom' },
    { value: 76, label: 'GD', name: 'Grenada' },
    { value: 77, label: 'GE', name: 'Georgia' },
    { value: 78, label: 'GF', name: 'French Guiana' },
    { value: 79, label: 'GG', name: 'Guernsey' },
    { value: 80, label: 'GH', name: 'Ghana' },
    { value: 81, label: 'GI', name: 'Gibraltar' },
    { value: 82, label: 'GL', name: 'Greenland' },
    { value: 83, label: 'GM', name: 'Gambia' },
    { value: 84, label: 'GN', name: 'Guinea' },
    { value: 85, label: 'GP', name: 'Guadeloupe' },
    { value: 86, label: 'GQ', name: 'Equatorial Guinea' },
    { value: 87, label: 'GR', name: 'Greece' },
    {
      value: 88,
      label: 'GS',
      name: 'South Georgia and the South Sandwich Islands',
    },
    { value: 89, label: 'GT', name: 'Guatemala' },
    { value: 90, label: 'GU', name: 'Guam' },
    { value: 91, label: 'GW', name: 'Guinea-Bissau' },
    { value: 92, label: 'GY', name: 'Guyana' },
    { value: 93, label: 'HK', name: 'Hong Kong, SAR China' },
    { value: 94, label: 'HM', name: 'Heard and Mcdonald Islands' },
    { value: 95, label: 'HN', name: 'Honduras' },
    { value: 96, label: 'HR', name: 'Croatia' },
    { value: 97, label: 'HT', name: 'Haiti' },
    { value: 98, label: 'HU', name: 'Hungary' },
    { value: 99, label: 'ID', name: 'Indonesia' },
    { value: 100, label: 'IE', name: 'Ireland' },
    { value: 101, label: 'IL', name: 'Israel' },
    { value: 102, label: 'IM', name: 'Isle of Man' },
    { value: 103, label: 'IN', name: 'India' },
    { value: 104, label: 'IO', name: 'British Indian Ocean Territory' },
    { value: 105, label: 'IQ', name: 'Iraq' },
    { value: 106, label: 'IR', name: 'Iran, Islamic Republic of' },
    { value: 107, label: 'IS', name: 'Iceland' },
    { value: 108, label: 'IT', name: 'Italy' },
    { value: 109, label: 'JE', name: 'Jersey' },
    { value: 110, label: 'JM', name: 'Jamaica' },
    { value: 111, label: 'JO', name: 'Jordan' },
    { value: 112, label: 'JP', name: 'Japan' },
    { value: 113, label: 'KE', name: 'Kenya' },
    { value: 114, label: 'KG', name: 'Kyrgyzstan' },
    { value: 115, label: 'KH', name: 'Cambodia' },
    { value: 116, label: 'KI', name: 'Kiribati' },
    { value: 117, label: 'KM', name: 'Comoros' },
    { value: 118, label: 'KN', name: 'Saint Kitts and Nevis' },
    { value: 119, label: 'KP', name: 'Korea (North)' },
    { value: 120, label: 'KR', name: 'Korea (South)' },
    { value: 121, label: 'KW', name: 'Kuwait' },
    { value: 122, label: 'KY', name: 'Cayman Islands' },
    { value: 123, label: 'KZ', name: 'Kazakhstan' },
    { value: 124, label: 'LA', name: 'Lao PDR' },
    { value: 125, label: 'LB', name: 'Lebanon' },
    { value: 126, label: 'LC', name: 'Saint Lucia' },
    { value: 127, label: 'LI', name: 'Liechtenstein' },
    { value: 128, label: 'LK', name: 'Sri Lanka' },
    { value: 129, label: 'LR', name: 'Liberia' },
    { value: 130, label: 'LS', name: 'Lesotho' },
    { value: 131, label: 'LT', name: 'Lithuania' },
    { value: 132, label: 'LU', name: 'Luxembourg' },
    { value: 133, label: 'LV', name: 'Latvia' },
    { value: 134, label: 'LY', name: 'Libya' },
    { value: 135, label: 'MA', name: 'Morocco' },
    { value: 136, label: 'MC', name: 'Monaco' },
    { value: 137, label: 'MD', name: 'Moldova' },
    { value: 138, label: 'ME', name: 'Montenegro' },
    { value: 139, label: 'MF', name: 'Saint-Martin (French part)' },
    { value: 140, label: 'MG', name: 'Madagascar' },
    { value: 141, label: 'MH', name: 'Marshall Islands' },
    { value: 142, label: 'MK', name: 'Macedonia, Republic of' },
    { value: 143, label: 'ML', name: 'Mali' },
    { value: 144, label: 'MM', name: 'Myanmar' },
    { value: 145, label: 'MN', name: 'Mongolia' },
    { value: 146, label: 'MO', name: 'Macao, SAR China' },
    { value: 147, label: 'MP', name: 'Northern Mariana Islands' },
    { value: 148, label: 'MQ', name: 'Martinique' },
    { value: 149, label: 'MR', name: 'Mauritania' },
    { value: 150, label: 'MS', name: 'Montserrat' },
    { value: 151, label: 'MT', name: 'Malta' },
    { value: 152, label: 'MU', name: 'Mauritius' },
    { value: 153, label: 'MV', name: 'Maldives' },
    { value: 154, label: 'MW', name: 'Malawi' },
    { value: 155, label: 'MX', name: 'Mexico' },
    { value: 156, label: 'MY', name: 'Malaysia' },
    { value: 157, label: 'MZ', name: 'Mozambique' },
    { value: 158, label: 'NA', name: 'Namibia' },
    { value: 159, label: 'NC', name: 'New Caledonia' },
    { value: 160, label: 'NE', name: 'Niger' },
    { value: 161, label: 'NF', name: 'Norfolk Island' },
    { value: 162, label: 'NG', name: 'Nigeria' },
    { value: 163, label: 'NI', name: 'Nicaragua' },
    { value: 164, label: 'NL', name: 'Netherlands' },
    { value: 165, label: 'NO', name: 'Norway' },
    { value: 166, label: 'NP', name: 'Nepal' },
    { value: 167, label: 'NR', name: 'Nauru' },
    { value: 168, label: 'NU', name: 'Niue' },
    { value: 169, label: 'NZ', name: 'New Zealand' },
    { value: 170, label: 'OM', name: 'Oman' },
    { value: 171, label: 'PA', name: 'Panama' },
    { value: 172, label: 'PE', name: 'Peru' },
    { value: 173, label: 'PF', name: 'French Polynesia' },
    { value: 174, label: 'PG', name: 'Papua New Guinea' },
    { value: 175, label: 'PH', name: 'Philippines' },
    { value: 176, label: 'PK', name: 'Pakistan' },
    { value: 177, label: 'PL', name: 'Poland' },
    { value: 178, label: 'PM', name: 'Saint Pierre and Miquelon' },
    { value: 179, label: 'PN', name: 'Pitcairn' },
    { value: 180, label: 'PR', name: 'Puerto Rico' },
    { value: 181, label: 'PS', name: 'Palestinian Territory' },
    { value: 182, label: 'PT', name: 'Portugal' },
    { value: 183, label: 'PW', name: 'Palau' },
    { value: 184, label: 'PY', name: 'Paraguay' },
    { value: 185, label: 'QA', name: 'Qatar' },
    { value: 186, label: 'RE', name: 'Réunion' },
    { value: 187, label: 'RO', name: 'Romania' },
    { value: 188, label: 'RS', name: 'Serbia' },
    { value: 189, label: 'RU', name: 'Russian Federation' },
    { value: 190, label: 'RW', name: 'Rwanda' },
    { value: 191, label: 'SA', name: 'Saudi Arabia' },
    { value: 192, label: 'SB', name: 'Solomon Islands' },
    { value: 193, label: 'SC', name: 'Seychelles' },
    { value: 194, label: 'SD', name: 'Sudan' },
    { value: 195, label: 'SE', name: 'Sweden' },
    { value: 196, label: 'SG', name: 'Singapore' },
    { value: 197, label: 'SH', name: 'Saint Helena' },
    { value: 198, label: 'SI', name: 'Slovenia' },
    { value: 199, label: 'SJ', name: 'Svalbard and Jan Mayen Islands' },
    { value: 200, label: 'SK', name: 'Slovakia' },
    { value: 201, label: 'SL', name: 'Sierra Leone' },
    { value: 202, label: 'SM', name: 'San Marino' },
    { value: 203, label: 'SN', name: 'Senegal' },
    { value: 204, label: 'SO', name: 'Somalia' },
    { value: 205, label: 'SR', name: 'Suriname' },
    { value: 206, label: 'SS', name: 'South Sudan' },
    { value: 207, label: 'ST', name: 'Sao Tome and Principe' },
    { value: 208, label: 'SV', name: 'El Salvador' },
    { value: 209, label: 'SY', name: 'Syrian Arab Republic (Syria)' },
    { value: 210, label: 'SZ', name: 'Swaziland' },
    { value: 211, label: 'TC', name: 'Turks and Caicos Islands' },
    { value: 212, label: 'TD', name: 'Chad' },
    { value: 213, label: 'TF', name: 'French Southern Territories' },
    { value: 214, label: 'TG', name: 'Togo' },
    { value: 215, label: 'TH', name: 'Thailand' },
    { value: 216, label: 'TJ', name: 'Tajikistan' },
    { value: 217, label: 'TK', name: 'Tokelau' },
    { value: 218, label: 'TL', name: 'Timor-Leste' },
    { value: 219, label: 'TM', name: 'Turkmenistan' },
    { value: 220, label: 'TN', name: 'Tunisia' },
    { value: 221, label: 'TO', name: 'Tonga' },
    { value: 222, label: 'TR', name: 'Turkey' },
    { value: 223, label: 'TT', name: 'Trinidad and Tobago' },
    { value: 224, label: 'TV', name: 'Tuvalu' },
    { value: 225, label: 'TW', name: 'Taiwan, Republic of China' },
    { value: 226, label: 'TZ', name: 'Tanzania, United Republic of' },
    { value: 227, label: 'UA', name: 'Ukraine' },
    { value: 228, label: 'UG', name: 'Uganda' },
    { value: 229, label: 'UM', name: 'US Minor Outlying Islands' },
    { value: 230, label: 'US', name: 'United States of America' },
    { value: 231, label: 'UY', name: 'Uruguay' },
    { value: 232, label: 'UZ', name: 'Uzbekistan' },
    { value: 233, label: 'VA', name: 'Holy See (Vatican City State)' },
    { value: 234, label: 'VC', name: 'Saint Vincent and Grenadines' },
    { value: 235, label: 'VE', name: 'Venezuela (Bolivarian Republic)' },
    { value: 236, label: 'VG', name: 'British Virgin Islands' },
    { value: 237, label: 'VI', name: 'Virgin Islands, US' },
    { value: 238, label: 'VN', name: 'Viet Nam' },
    { value: 239, label: 'VU', name: 'Vanuatu' },
    { value: 240, label: 'WF', name: 'Wallis and Futuna Islands' },
    { value: 241, label: 'WS', name: 'Samoa' },
    { value: 242, label: 'YE', name: 'Yemen' },
    { value: 243, label: 'YT', name: 'Mayotte' },
    { value: 244, label: 'ZA', name: 'South Africa' },
    { value: 245, label: 'ZM', name: 'Zambia' },
    { value: 246, label: 'ZW', name: 'Zimbabwe' },
  ],
});
